import React from 'react';
import ReactDOM from 'react-dom';
import { ModalBackground, ModalContentWrapper } from './style';
import { compose, lifecycle } from 'recompose';

const ROOT_ELEMENT = document.getElementById('root');
const BODY = document.body;

const stopEventPropagation = e => {
    e.stopPropagation();
};

const ModalContainer = ({ onClose, children }) =>
    ReactDOM.createPortal(
        <ModalBackground onClick={onClose}>
            <ModalContentWrapper onClick={stopEventPropagation}>{children}</ModalContentWrapper>
        </ModalBackground>,
        ROOT_ELEMENT,
    );

export default compose(
    lifecycle({
        componentDidMount() {
            BODY.style.overflow = 'hidden';
        },
        componentWillUnmount() {
            BODY.style.overflow = 'auto';
        },
    }),
)(ModalContainer);



// WEBPACK FOOTER //
// ./src/UI/Containers/Modals/ModalContainer.js